
class EditableGridSelectionStorage {
  constructor(listeners) {
    this.selected = [];
    this.listeners = listeners || [];
  }
  addSelectedItem(rowIndex) {
    console.log("Added selected rowIndex:",rowIndex)
    this.selected.push(rowIndex);
    for (const l of this.listeners) {
      l.onSelectionChange(rowIndex/*added*/, null/*removed*/);
    }
  }

  toggleSelectedItem(rowIndex) {
    var arrIndex = this.selected.indexOf(rowIndex);
    if (arrIndex === -1) {
      console.log("Added selected rowIndex:",rowIndex)
      this.selected.push(rowIndex);
      for (const l of this.listeners) {
        l.onSelectionChange(rowIndex/*added*/, null/*removed*/);
      }
    }

    if(arrIndex !== -1){
      console.log("Removed selected rowIndex:",rowIndex)
      this.selected.splice(arrIndex, 1);
      for (const l of this.listeners) {
        l.onSelectionChange(null/*added*/, rowIndex/*removed*/);
      }
    }
  }

  resetSelection() {
    console.log("Reset selection:")
    if (this.selected.length) {
      let tmp = this.selected;
      this.selected = [];
      for (const l of this.listeners) {
        l.onSelectionChange(null/*added*/, tmp/*removed*/);
      }
    }
  }

  isSelected(rowIndex) {
    return  this.selected.indexOf(rowIndex) !== -1;
  }

  hasAnySelected() {
    return  this.selected.length > 0;
  }

  getSelectedRows() {
    return [...this.selected];
  }

  subscribe(listener) {
    this.listeners.push(listener);
  }

  unsubscribe(listener) {
    var index = this.listeners.indexOf(listener);
    if (index !== -1) this.listeners.splice(index, 1);
  }

}

export default EditableGridSelectionStorage;